import UseContext from "hooks/useContext";


const useModal = () => {
    const {modalShow,setModalShow,setModalType}=UseContext()


    const toggle = (v) => {
        if (v) setModalType(v);
        setModalShow((prev) => !prev);
    };

    return {
        toggle
    };
};

export default useModal;